import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "captcha-warp"
};
const _hoisted_2 = {
  id: "CaptchaEl",
  ref: "CaptchaEl",
  "data-appid": "2036785952",
  "data-cbfn": "captchaCb",
  "data-module": "0",
  type: "primary",
  style: {
    "display": "none"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RemoteJs = _resolveComponent("RemoteJs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, null, 512), _createVNode(_component_RemoteJs, {
    src: "https://captcha.253.com/Captcha.js"
  })]);
}